import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Modal, TextContainer, TextStyle, Banner } from '@shopify/polaris';

const propTypes = {
  currentAPB: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onAction: PropTypes.func.isRequired,

  open: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
};

const defaultProps = {

}


const APBChangeModal = ({ currentAPB: apb, ...props }) => (
  <Modal
    title="APB"
    large
    open={props.open}
    onClose={props.onClose}
    primaryAction={{
      content: apb ? I18n.t("actions.disable") : I18n.t("actions.enable"),
      onAction: props.onAction,
      disabled: props.disabled
    }}
    secondaryActions={[
      { 
        content: I18n.t("actions.close"),
        onAction: props.onClose
      },
    ]
  }
  >
    <Modal.Section>
      <TextContainer>
        { props.disabled &&
          <div className="mb10">
            <Banner status="warning">
              <p>
                { I18n.t("app.messages.cannot_toggle_apb") }
              </p>
            </Banner>
          </div>
        }
        
        <TextStyle>
          { apb ? I18n.t("app.apb.enabled") : I18n.t("app.apb.disabled") }
        </TextStyle>
      </TextContainer>
    </Modal.Section>
  </Modal>
)

APBChangeModal.propTypes = propTypes;
APBChangeModal.defaultProps = defaultProps;

export default APBChangeModal;